module.exports = __webpack_public_path__ + "media/images/icons/eye-icon-3ab38c7bbef5cbbdd1650e9afe635769.svg";